import { UiStorage } from '@experiences/util';
import { User } from 'oidc-client-ts';

export default function setLastUsedOrganizationId(user: User) {
    UiStorage.setItem('lastUsedOrganizationId', user.profile.prt_id);
}
